import { NavLink, useLocation } from "react-router-dom";
import { useContext, useState } from "react";
import {
  Inbox,
  Calendar,
  TrendingUp,
  CloudDownload,
  MoreHorizontal,
} from "lucide-react";
import MobileMoreMenu from "./MobileMoreMenu";
import { cn } from "@/lib/utils";
import UserContext from "../contexts/UserContext";
import { isRestrictedEmployee } from "@/utils/permissions";

const BottomTabBar = () => {
  const location = useLocation();
  const [isMoreMenuOpen, setIsMoreMenuOpen] = useState(false);
  const { roles } = useContext(UserContext);

  const allTabs = [
    { path: "/inbox", label: "Bandeja", icon: Inbox },
    { path: "/activities", label: "Actividades", icon: Calendar },
    { path: "/analytics", label: "Analítica", icon: TrendingUp },
    { path: "/reports", label: "Reportes", icon: CloudDownload },
  ];

  // Restricted employees may only reach /inbox and /activities.
  const primaryTabs = isRestrictedEmployee(roles) ? allTabs.slice(0, 2) : allTabs;

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 z-[1000] flex border-t border-gray-200 bg-white px-2 py-1 pb-[env(safe-area-inset-bottom)] md:hidden">
        <div className="flex w-full justify-around">
          {primaryTabs.map((tab) => {
            const isActive = location.pathname.startsWith(tab.path);
            return (
              <NavLink
                key={tab.path}
                to={tab.path}
                className={cn(
                  "flex min-h-[44px] flex-1 flex-col items-center justify-center py-1",
                  isActive ? "text-palomma-primary" : "text-gray-500",
                  "hover:text-palomma-primary"
                )}
              >
                <tab.icon className="size-5" />
                <span className={cn("mt-0.5 text-[10px]", isActive && "font-bold")}>
                  {tab.label}
                </span>
              </NavLink>
            );
          })}
          <button
            className={cn(
              "flex min-h-[44px] flex-1 flex-col items-center justify-center py-1 cursor-pointer",
              isMoreMenuOpen ? "text-palomma-primary" : "text-gray-500"
            )}
            onClick={() => setIsMoreMenuOpen(true)}
          >
            <MoreHorizontal className="size-5" />
            <span className="mt-0.5 text-[10px]">Más</span>
          </button>
        </div>
      </div>
      <MobileMoreMenu isOpen={isMoreMenuOpen} onClose={() => setIsMoreMenuOpen(false)} />
    </>
  );
};

export default BottomTabBar;
